var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeOlhoDesligado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.15,
    viewBox: "0 0 22 19.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-1 -2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2556",
    "data-name": "Caminho 2556",
    d: "M12,6a9.77,9.77,0,0,1,8.82,5.5,9.647,9.647,0,0,1-2.41,3.12l1.41,1.41A11.8,11.8,0,0,0,23,11.5,11.834,11.834,0,0,0,8.36,4.57l1.65,1.65A10.108,10.108,0,0,1,12,6Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2557",
    "data-name": "Caminho 2557",
    d: "M10.93,7.14,13,9.21a2.5,2.5,0,0,1,1.28,1.28l2.07,2.07a4.679,4.679,0,0,0,.14-1.07A4.483,4.483,0,0,0,12,7,4.244,4.244,0,0,0,10.93,7.14Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2558",
    "data-name": "Caminho 2558",
    d: "M2.01,3.87,4.69,6.55A11.738,11.738,0,0,0,1,11.5,11.827,11.827,0,0,0,12,19a11.73,11.73,0,0,0,4.32-.82l3.42,3.42,1.41-1.41L3.42,2.45Zm7.5,7.5,2.61,2.61A.5.5,0,0,1,12,14a2.5,2.5,0,0,1-2.5-2.5C9.5,11.45,9.51,11.42,9.51,11.37Zm-3.4-3.4L7.86,9.72A4.6,4.6,0,0,0,7.5,11.5a4.505,4.505,0,0,0,6.27,4.14l.98.98A10.432,10.432,0,0,1,12,17a9.77,9.77,0,0,1-8.82-5.5A9.9,9.9,0,0,1,6.11,7.97Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeOlhoDesligado);
export default __webpack_public_path__ + "static/media/icone-olho-desligado.eab38494d2c8a81f8e2347345b8f8410.svg";
export { ForwardRef as ReactComponent };